import { IGif } from '@giphy/js-types'
import React, { SyntheticEvent } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMServer from 'react-dom/server'
import { useWindowSize } from 'react-use'
import { App } from '../../src/app'
import { Large, Small } from '../../src/constants'
import GifDisplay from '../components/gif-display'
import { SendingGif } from './style'

// cut and paste from
// https://docs.microsoft.com/en-us/outlook/add-ins/insert-data-in-the-body
function setItemBody(staticMarkup: string) {
    const write = (message: string) => {
        const messageEl = document.getElementById('message')
        if (messageEl) messageEl.innerHTML += message
    }
    const { item } = Office.context.mailbox
    item.body.getTypeAsync((result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
            write(result.error.message)
        } else {
            // Successfully got the type of item body.
            // Set data of the appropriate type in body.
            if (result.value === Office.CoercionType.Html) {
                // Body is of HTML type.
                // Specify HTML in the coercionType parameter
                // of setSelectedDataAsync.
                item.body.setSelectedDataAsync(
                    staticMarkup,
                    { coercionType: Office.CoercionType.Html, asyncContext: { var3: 1, var4: 2 } },
                    (asyncResult) => {
                        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                            write(asyncResult.error.message)
                        } else {
                            // Successfully set data in item body.
                            // Do whatever appropriate for your scenario,
                            // using the arguments var3 and var4 as applicable.
                        }
                    },
                )
            } else {
                // Body is of text type.
                item.body.setSelectedDataAsync(
                    `GIFs can't be displayed in text only emails`,
                    { coercionType: Office.CoercionType.Text, asyncContext: { var3: 1, var4: 2 } },
                    (asyncResult) => {
                        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                            write(asyncResult.error.message)
                        } else {
                            // Successfully set data in item body.
                            // Do whatever appropriate for your scenario,
                            // using the arguments var3 and var4 as applicable.
                        }
                    },
                )
            }
        }
    })
}

// Get the message Id
function getItemRestId() {
    if (Office.context.mailbox.diagnostics.hostName === 'OutlookIOS') {
        // itemId is already REST-formatted.
        return Office.context.mailbox.item.itemId
    } else {
        // Convert to an item ID for API v2.0.
        return Office.context.mailbox.convertToRestId(
            Office.context.mailbox.item.itemId,
            Office.MailboxEnums.RestVersion.v2_0,
        )
    }
}

function replyWithGif(staticMarkup: string) {
    const sendingGifDiv = document.getElementById('sending-gif')
    if (sendingGifDiv) sendingGifDiv.style.display = 'flex' // show loading

    Office.context.mailbox.getCallbackTokenAsync(
        {
            isRest: true,
        },
        (result) => {
            const fullUrl = Office.context.mailbox.restUrl + '/v2.0/me/messages/' + getItemRestId() + '/reply'
            fetch(fullUrl, {
                headers: { Authorization: `Bearer ${result.value}`, 'Content-Type': 'application/json' },
                method: 'POST',
                body: JSON.stringify({
                    Comment: staticMarkup,
                }),
            }).then(() => {
                Office.context.ui.closeContainer()
            })
        },
    )
}

const target = document.getElementById('react-target')!
const config = location.search.indexOf('large') !== -1 ? Large : Small
const insertGif = (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => {
    const staticMarkup = ReactDOMServer.renderToStaticMarkup(<GifDisplay gif={gif} />)

    // If is inside a message, reply with GIF
    if (Office.context.mailbox.item.displayReplyForm !== undefined) {
        replyWithGif(staticMarkup)
    } else {
        // If not, insert to body
        setItemBody(staticMarkup)
    }

    e?.preventDefault()
    return false
}

const RenderWithSize = () => {
    const { width } = useWindowSize()

    return (
        <div id="grid-container">
            <SendingGif id="sending-gif">Replying with GIF...</SendingGif>
            <App config={{ ...config, flexVertical: true, width }} onGifClick={insertGif} apiKey="uV9L751ob0otG" />
        </div>
    )
}

Office.onReady().then(() => {
    ReactDOM.render(<RenderWithSize />, target)
})

declare const module: any
// Hot Module Replacement
if (module.hot) {
    module.hot.accept()
}
